import Auth from '@nal/components/Auth/store/reducer';
import Me from '@nal/components/CurrentUser/store/reducer';
import Routing from './routing/reducer';
import PageLoading from './page-loading/PageLoadingReducer';

export default {
    Auth,
    Routing,
    PageLoading,
    Me,
};
